import { render, staticRenderFns } from "./ThemeExample.vue?vue&type=template&id=1bf062a7&scoped=true"
import script from "./ThemeExample.vue?vue&type=script&lang=js"
export * from "./ThemeExample.vue?vue&type=script&lang=js"
import style0 from "./ThemeExample.vue?vue&type=style&index=0&id=1bf062a7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf062a7",
  null
  
)

export default component.exports